import styled from "@emotion/styled"
import { Button, IconButton, Typography } from "@mui/material"
import { useTranslations } from "next-intl"
import Image from "next/image"
import { Link, type Result } from "utils"
import { sharedColors } from "../../theme/colors"

const StyledContainer = styled.div`
  position: fixed;
  top: 64px; /* Leave space for the header */
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: calc(100vh - 80px); /* Adjust height */
  display: flex;
  flex-direction: column;
  background-color: white;
  z-index: 1000;
`

const StyledLayout = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`

const StyledModalBox = styled.div`
  border-radius: 12px;
  width: 100%;
  display: flex;
  height: 56px;
  padding: 12px;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  background-color: white;
  border: 1px solid ${sharedColors.black};
`

const StyledSubmitButton = styled(IconButton)`
  display: flex;
  width: 40px;
  height: 40px;
  padding: 0px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 12px;
  background-color: ${sharedColors.brandDark};
  :hover {
    box-shadow:
      0px 4px 12px 0px rgba(0, 0, 0, 0.16),
      inset 0px 0px 0px 2px ${sharedColors.brandDark};
    background-color: ${sharedColors.brandDark};
  }
`

const ContentLayout = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  overflow: hidden;
  padding-left: 16px;
  padding-right: 16px;
  gap: 16px;
`

const ResultsLayout = styled.div`
  display: flex;
  flex-direction: column;
`

const ResultsItem = styled(Link)`
  display: flex;
  padding: 16px 0px;
  align-items: center;
  gap: 12px;
  border-bottom: 1px solid ${sharedColors.borderGray};
  text-decoration: none;
`

const EmptyResultsBox = styled.div`
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 32px;
  height: 400px;
  justify-content: center;
  align-items: center;
`

const EmptyText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

type Props = {
  handleClose: () => void
  array: Result
  text: string
}

export const SearchSheet = ({ handleClose, array, text }: Props) => {
  const t = useTranslations("Homepage")
  const tInner = useTranslations("InnerPages")
  return (
    <StyledLayout>
      <ContentLayout>
        {array && array.length > 0 ? (
          <ResultsLayout>
            {array.map((item, index) => (
              <ResultsItem key={index} href={item.url} onClick={handleClose}>
                <Typography variant="body1">{item.title}</Typography>
              </ResultsItem>
            ))}
          </ResultsLayout>
        ) : null}
        {array && array.length === 0 ? (
          <EmptyResultsBox>
            <Image src="/images/cactus.png" alt="" width={168} height={168} />
            <EmptyText>
              <Typography variant="h3">{t("noResultsFound")}</Typography>
              <Typography variant="body2">
                {t("weDidNotFindRes")}
                {` ${text}`}
              </Typography>
            </EmptyText>
            <Link href={"/"} onClick={handleClose}>
              <Button variant="secondary" style={{ width: "300px" }}>
                {tInner("backToHomepage")}
              </Button>
            </Link>
          </EmptyResultsBox>
        ) : null}
      </ContentLayout>
    </StyledLayout>
  )
}
